const o={"á":"a","à":"a","â":"a","å":"a","ä":"a","ã":"a","ç":"c","é":"e","è":"e","ê":"e","ë":"e","í":"i","ì":"i","î":"i","ï":"i","ñ":"n","ó":"o","ò":"o","ô":"o","ö":"o","õ":"o","ú":"u","ù":"u","û":"u","ü":"u"};export{o as CHAR_MAP};
